import React from "react";
import { useTranslation } from "react-i18next";
import { TypeSpecificFieldsProps } from "./types";

const HealthFields: React.FC<TypeSpecificFieldsProps> = ({ data, onChange }) => {
  const { t } = useTranslation(['insurance', 'common']);
  const set = (key: string, value: any) => onChange({ ...data, [key]: value });

  return (
    <div className="irf-grid">
      <div className="irf-field">
        <label>{t('insurance:health.roomRentLimit')}</label>
        <input
          value={data.room_rent_limit || ""}
          onChange={(e) => set("room_rent_limit", e.target.value)}
          placeholder={t('insurance:health.roomRentLimitPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:health.copayPercentage')}</label>
        <input
          type="number"
          value={data.copay_percentage ?? ""}
          onChange={(e) => set("copay_percentage", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:health.copayPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:health.deductible')}</label>
        <input
          type="number"
          value={data.deductible ?? ""}
          onChange={(e) => set("deductible", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:health.deductiblePlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:common.tpaName')}</label>
        <input
          value={data.tpa_name || ""}
          onChange={(e) => set("tpa_name", e.target.value)}
          placeholder={t('insurance:common.tpaNamePlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:health.networkHospitals')}</label>
        <input
          value={data.network_hospitals || ""}
          onChange={(e) => set("network_hospitals", e.target.value)}
          placeholder={t('insurance:health.networkHospitalsPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:health.waitingPeriodDays')}</label>
        <input
          type="number"
          value={data.waiting_period_days ?? ""}
          onChange={(e) => set("waiting_period_days", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:health.waitingPeriodDaysPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:health.preExistingWaitingYears')}</label>
        <input
          type="number"
          value={data.pre_existing_waiting_years ?? ""}
          onChange={(e) => set("pre_existing_waiting_years", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:health.preExistingWaitingYearsPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:health.noClaimBonus')}</label>
        <input
          type="number"
          value={data.no_claim_bonus_percentage ?? ""}
          onChange={(e) => set("no_claim_bonus_percentage", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:health.noClaimBonusPlaceholder')}
        />
      </div>
      <div className="irf-field irf-checkbox-field">
        <label>
          <input
            type="checkbox"
            checked={!!data.maternity_cover}
            onChange={(e) => set("maternity_cover", e.target.checked)}
          />
          {t('insurance:health.maternityCover')}
        </label>
      </div>
      <div className="irf-field irf-checkbox-field">
        <label>
          <input
            type="checkbox"
            checked={!!data.day_care_cover}
            onChange={(e) => set("day_care_cover", e.target.checked)}
          />
          {t('insurance:health.dayCareCover')}
        </label>
      </div>
    </div>
  );
};

export default HealthFields;
